import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import request from 'app/requests/Lane/OrderNotificationSettings.requests'
import {
    NotificationsSettingsType,
} from '../../lanes.types'

const useGetNotificationsSettings = (laneId: number) => {
    return useRequest<NotificationsSettingsType>({
        key: RequestKeys.getLaneNotificationsSettings,
        params: {
            id: laneId,
        },
        requestFunc: RequestFn.getEntity(request.get),
        enabled: Boolean(laneId),
        keepPreviousData: true,
    })
}

export default useGetNotificationsSettings
